export const navBarItems = [
    {
        id: "1",
        path: "/Buchete-flori",
        name: "Buchete flori",
        cName: "nav-item",
        component: "BucheteFlori",
        subRoutes: [
            {
                id: "1",
                path: "/Buchete-flori/Buchete-de-orhidee",
                name: "Buchete de orhidee",
                cName: "nav-dropdown",
                component: "BucheteDeOrhidee"
            },
            {
                id: "2",
                path: "/Buchete-flori/Buchete-de-trandafiri",
                name: "Buchete de trandafiri",
                cName: "nav-dropdown",
                component: "BucheteDeTrandafiri"
            },
            {
                id: "3",
                path: "/Buchete-flori/Buchete-de-lalele",
                name: "Buchete de lalele",
                cName: "nav-dropdown",
                component: "BucheteDeLalele"
            },
            {
                id: "4",
                path: "/Buchete-flori/Buchete-de-minirosa",
                name: "Buchete de minirosa",
                cName: "nav-dropdown",
                component: "BucheteDeMinirosa"
            },
            {
                id: "5",
                path: "/Buchete-flori/Buchete-de-crizanteme",
                name: "Buchete de crizanteme",
                cName: "nav-dropdown",
                component: "BucheteDeCrizanteme"
            },
            {
                id: "6",
                path: "/Buchete-flori/Buchete-de-garoafe",
                name: "Buchete de garoafe",
                cName: "nav-dropdown",
                component: "BucheteDeGaroafe"
            },
            {
                id: "7",
                path: "/Buchete-flori/Buchete-cu-Hortensie",
                name: "Buchete cu Hortensie",
                cName: "nav-dropdown",
                component: "BucheteCuHortensie"
            },
            {
                id: "8",
                path: "/Buchete-flori/Buchete-de-gerbera",
                name: "Buchete de gerbera",
                cName: "nav-dropdown",
                component: "BucheteDeGerbera"
            },
            {
                id: "9",
                path: "/Buchete-flori/Buchete-de-crini-imperiali",
                name: "Buchete de crini imperiali",
                cName: "nav-dropdown",
                component: "BucheteDeCriniImperiali"
            },
            {
                id: "10",
                path: "/Buchete-flori/Buchete-de-crini-asiatici",
                name: "Buchete de crini asiatici",
                cName: "nav-dropdown",
                component: "BucheteDeCriniAsiatici"
            },
            {
                id: "11",
                path: "/Buchete-flori/Buchete-de-iris",
                name: "Buchete de iris",
                cName: "nav-dropdown",
                component: "BucheteDeIris"
            },
            {
                id: "12",
                path: "/Buchete-flori/Buchete-de-alstroemeria",
                name: "Buchete de alstroemeria",
                cName: "nav-dropdown",
                component: "BucheteDeAlstroemeria"
            },
            {
                id: "13",
                path: "/Buchete-flori/Buchete-de-cale",
                name: "Buchete de cale",
                cName: "nav-dropdown",
                component: "BucheteDeCale"
            },
            {
                id: "14",
                path: "/Buchete-flori/Buchete-Mireasa",
                name: "Buchete Mireasa",
                cName: "nav-dropdown",
                component: "BucheteMireasa"
            },
            {
                id: "15",
                path: "/Buchete-flori/Buchete-de-lisianthus",
                name: "Buchete de lisianthus",
                cName: "nav-dropdown",
                component: "BucheteDeLisianthus"
            },
            {
                id: "16",
                path: "/Buchete-flori/Flori-de-Primavara",
                name: "Flori de Primavara",
                cName: "nav-dropdown",
                component: "FloriDePrimavara"
            },
            {
                id: "17",
                path: "/Buchete-flori/Flori-de-Vara",
                name: "Flori de Vara",
                cName: "nav-dropdown",
                component: "FloriDeVara"
            },
            {
                id: "18",
                path: "/Buchete-flori/Flori-de-Iarna",
                name: "Flori de Iarna",
                cName: "nav-dropdown",
                component: "FloriDeIarna"
            },
            {
                id: "19",
                path: "/Buchete-flori/Buchete-ambalate-in-cutie",
                name: "Buchete ambalate in cutie",
                cName: "nav-dropdown",
                component: "BucheteAmbalateInCutie"
            },
            {
                id: "20",
                path: "/Buchete-flori/Buchete-cu-Bujori",
                name: "Buchete cu Bujori",
                cName: "nav-dropdown",
                component: "BucheteCuBujori"
            },
        ]
    },
    {
        id: "2",
        path: "/Aranjamente-florale",
        name: "Aranjamente florale",
        cName: "nav-item",
        component: "AranjamenteFlorale",
        subRoutes: [
            {
                id: "1",
                path: "/Aranjamente-florale/Flori-in-cutie",
                name: "Flori in cutie",
                cName: "nav-dropdown",
                component: "FloriInCutie"
            },
            {
                id: "2",
                path: "/Aranjamente-florale/Cosuri-cu-flori",
                name: "Cosuri cu flori",
                cName: "nav-dropdown",
                component: "CosuriCuFlori"
            },
            {
                id: "3",
                path: "/Aranjamente-florale/Aranjamente-corporate",
                name: "Aranjamente corporate",
                cName: "nav-dropdown",
                component: "AranjamenteCorporate"
            },
            {
                id: "4",
                path: "/Aranjamente-florale/Plante",
                name: "Plante",
                cName: "nav-dropdown",
                component: "Plante"
            },
            {
                id: "5",
                path: "/Aranjamente-florale/Trandafiri-criogenati",
                name: "Trandafiri criogenati",
                cName: "nav-dropdown",
                component: "TrandafiriCriogenati"
            },
            {
                id: "6",
                path: "/Aranjamente-florale/Coronite-flori",
                name: "Coronite flori",
                cName: "nav-dropdown",
                component: "CoroniteFlori"
            },
            {
                id: "7",
                path: "/Aranjamente-florale/Inimi-Florale",
                name: "Inimi Florale",
                cName: "nav-dropdown",
                component: "InimiFlorale"
            },
        ]
    },
    {
        id: "3",
        path: "/Ocazii-si-evenimente",
        name: "Ocazii si evenimente",
        cName: "nav-item",
        component: "OcaziiSiEvenimente",
        subRoutes: [
            {
                id: "1",
                path: "/Ocazii-si-evenimente/Flori-Onomastica",
                name: "Flori Onomastica",
                cName: "nav-dropdown",
                component: "FloriOnomastica"
            },
            {
                id: "2",
                path: "/Ocazii-si-evenimente/Buchete-La-Multi-Ani",
                name: "Buchete La Multi Ani",
                cName: "nav-dropdown",
                component: "BucheteLaMultiAni"
            },
            {
                id: "3",
                path: "/Ocazii-si-evenimente/Ocazii-speciale",
                name: "Ocazii speciale",
                cName: "nav-dropdown",
                component: "OcaziiSpeciale"
            },
            {
                id: "4",
                path: "/Ocazii-si-evenimente/Coroane-funerare",
                name: "Coroane funerare",
                cName: "nav-dropdown",
                component: "CoroaneFunerare"
            },
            {
                id: "5",
                path: "/Ocazii-si-evenimente/Flori-pentru-nunta",
                name: "Flori pentru nunta",
                cName: "nav-dropdown",
                component: "FloriPentruNunta"
            },
            {
                id: "6",
                path: "/Ocazii-si-evenimente/Flori-Halloween",
                name: "Flori Halloween",
                cName: "nav-dropdown",
                component: "FloriHalloween"
            },
            {
                id: "7",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Andrei",
                name: "Flori Sfantul Andrei",
                cName: "nav-dropdown",
                component: "FloriSfantulAndrei"
            },
            {
                id: "8",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Stefan",
                name: "Flori Sfantul Stefan",
                cName: "nav-dropdown",
                component: "FloriSfantulStefan"
            },
            {
                id: "9",
                path: "/Ocazii-si-evenimente/Flori-Constantin-si-Elena",
                name: "Flori Constantin si Elena",
                cName: "nav-dropdown",
                component: "FloriConstantinSiElena"
            },
            {
                id: "10",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Nicolae",
                name: "Flori Sfantul Nicolae",
                cName: "nav-dropdown",
                component: "FloriSfantulNicolae"
            },
            {
                id: "11",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Ioan",
                name: "Flori Sfantul Ioan",
                cName: "nav-dropdown",
                component: "FloriSfantulIoan"
            },
            {
                id: "12",
                path: "/Ocazii-si-evenimente/Flori-Sfanta-Maria",
                name: "Flori Sfanta Maria",
                cName: "nav-dropdown",
                component: "FloriSfantaMaria"
            },
            {
                id: "13",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Gheorghe",
                name: "Flori Sfantul Gheorghe",
                cName: "nav-dropdown",
                component: "FloriSfantulGheorghe"
            },
            {
                id: "14",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Alexandru",
                name: "Flori Sfantul Alexandru",
                cName: "nav-dropdown",
                component: "FloriSfantulAlexandru"
            },
            {
                id: "15",
                path: "/Ocazii-si-evenimente/Flori-Sfanta-Ana",
                name: "Flori Sfanta Ana",
                cName: "nav-dropdown",
                component: "FloriSfantaAna"
            },
            {
                id: "16",
                path: "/Ocazii-si-evenimente/Flori-Sfantul-Dumitru",
                name: "Flori Sfantul Dumitru",
                cName: "nav-dropdown",
                component: "FloriSfantulDumitru"
            },
            {
                id: "17",
                path: "/Ocazii-si-evenimente/Flori-Florii",
                name: "Flori Florii",
                cName: "nav-dropdown",
                component: "FloriFlorii"
            },
            {
                id: "18",
                path: "/Ocazii-si-evenimente/Sfintii-Mihail-si-Gavril",
                name: "Sfintii Mihail si Gavril",
                cName: "nav-dropdown",
                component: "SfintiiMihailSiGavril"
            },
            {
                id: "19",
                path: "/Ocazii-si-evenimente/Flori-8-Martie",
                name: "Flori 8 Martie",
                cName: "nav-dropdown",
                component: "Flori8Martie"
            },
            {
                id: "20",
                path: "/Ocazii-si-evenimente/Flori-1-Martie",
                name: "Flori 1 Martie",
                cName: "nav-dropdown",
                component: "Flori1Martie"
            },
            {
                id: "21",
                path: "/Flori-Valentines-Day",
                name: "Flori Valentines Day",
                cName: "nav-dropdown",
                component: "FloriValentinesDay"
            },
            {
                id: "22",
                path: "/Ocazii-si-evenimente/Aranjamente-&-Brazi-de-Craciun",
                name: "Aranjamente & Brazi de Craciun",
                cName: "nav-dropdown",
                component: "AranjamenteSiBraziDeCraciun"
            },
            {
                id: "23",
                path: "/Ocazii-si-evenimente/Flori-de-Dragobete",
                name: "Flori de Dragobete",
                cName: "nav-dropdown",
                component: "FloriDeDragobete"
            },
        ]
    },
    {
        id: "4",
        path: "/Cadouri",
        name: "Cadouri",
        cName: "nav-item",
        component: "Cadouri",
        subRoutes: [
            {
                id: "1",
                path: "/Cadouri/Cadouri-speciale",
                name: "Cadouri speciale",
                cName: "nav-dropdown",
                component: "CadouriSpeciale"
            },
            {
                id: "2",
                path: "/Cadouri/Parfumuri",
                name: "Parfumuri",
                cName: "nav-dropdown",
                component: "Parfumuri"
            },
            {
                id: "3",
                path: "/Cadouri/Dulciuri",
                name: "Dulciuri",
                cName: "nav-dropdown",
                component: "Dulciuri"
            },
            {
                id: "4",
                path: "/Cadouri/Sampanie",
                name: "Sampanie",
                cName: "nav-dropdown",
                component: "Sampanie"
            },
            {
                id: "5",
                path: "/Cadouri/Jucarii-&-Cadouri",
                name: "Jucarii & Cadouri",
                cName: "nav-dropdown",
                component: "JucariiSiCadouri"
            },
            {
                id: "6",
                path: "/Cadouri/Cosuri,-Vaze-&-Accesorii",
                name: "Cosuri, Vaze & Accesorii",
                cName: "nav-dropdown",
                component: "CosuriVazeSiAccesorii"
            },
        ]
    },
]


